import React from 'react';
import PropTypes from 'prop-types';

function CharityCoinsIcon({ color }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      role="img"
      aria-labelledby="charity-coins-icon-title"
    >
      <title id="charity-coins-icon-title">Charity coins icon</title>
      <defs>
        <path
          id="path-charity-1"
          d="M23.289 8.72A10.24 10.24 0 0016 5.69c-2.845 0-5.419 1.15-7.289 3.03a10.224 10.224 0 00-3.021 7.29c0 2.82 1.15 5.42 3.021 7.28A10.301 10.301 0 0016 26.3c2.844 0 5.418-1.15 7.289-3.01 1.87-1.86 3.02-4.46 3.02-7.28 0-2.85-1.15-5.44-3.02-7.29zm2.429-2.44A13.702 13.702 0 0016 2.25c-3.796 0-7.233 1.55-9.718 4.03a13.7 13.7 0 00-4.029 9.73c0 3.78 1.535 7.22 4.029 9.71A13.678 13.678 0 0016 29.74c3.803 0 7.241-1.53 9.718-4.02a13.692 13.692 0 004.029-9.71c0-3.8-1.536-7.24-4.029-9.73zM16 0c4.411 0 8.423 1.8 11.299 4.69l.018.02.016.01a15.973 15.973 0 014.658 11.29c0 4.41-1.782 8.4-4.674 11.31h-.018l-.015.02A15.944 15.944 0 0116 32a15.93 15.93 0 01-11.301-4.68h-.016l-.016-.01C1.79 24.4 0 20.42 0 16.01c0-4.42 1.79-8.41 4.683-11.3l.016-.02.009-.02C7.608 1.8 11.604 0 16 0zm8.247 7.76a11.64 11.64 0 013.421 8.25c0 3.21-1.311 6.13-3.421 8.24A11.608 11.608 0 0116 27.66c-3.221 0-6.138-1.3-8.248-3.41a11.628 11.628 0 01-3.413-8.24c0-3.22 1.303-6.14 3.413-8.25A11.633 11.633 0 0116 4.34c3.229 0 6.137 1.31 8.247 3.42zm-7.609 5.075l-.007.007-1.715 1.635a.324.324 0 01-.455 0 .301.301 0 010-.438l1.089-1.036-.012-.022c-.466-.416-.997-.72-1.558-.861a3.017 3.017 0 00-1.639.044 3.431 3.431 0 00-1.31.766 2.961 2.961 0 00-.81 1.226 2.5 2.5 0 00-.057 1.481c.141.497.447.978.875 1.38l4.957 4.743 4.944-4.706.019-.037c.431-.402.733-.883.875-1.38.133-.47.13-.97-.054-1.481a3.004 3.004 0 00-.81-1.226 3.465 3.465 0 00-1.314-.763 3.002 3.002 0 00-1.635-.047 3.571 3.571 0 00-1.383.715zm-1.016 10.017l-5.348-5.098c-.557-.533-.958-1.175-1.145-1.854a3.405 3.405 0 01.068-2.068 4.15 4.15 0 011.085-1.64 4.394 4.394 0 011.742-1.007 4.158 4.158 0 012.231-.062c.626.16 1.219.464 1.741.884a4.548 4.548 0 011.75-.877 4.097 4.097 0 012.235.06 4.44 4.44 0 011.742 1.003c.485.46.867 1.018 1.077 1.642h.004c.244.704.252 1.408.069 2.065-.192.68-.589 1.32-1.15 1.854l-.027.019-5.317 5.079a.557.557 0 01-.757 0z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-1059 -1052)">
          <g transform="translate(136 965)">
            <g transform="translate(822 87)">
              <g transform="translate(101)">
                <mask id="mask-charity-2" fill="#ffffff">
                  <use xlinkHref="#path-charity-1" />
                </mask>
                <path
                  fill={`var(--${color})`}
                  d="M-5 -5L36.991 -5 36.991 37 -5 37z"
                  mask="url(#mask-charity-2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

CharityCoinsIcon.propTypes = {
  color: PropTypes.string,
};

CharityCoinsIcon.defaultProps = {
  color: 'white',
};

export default React.memo(CharityCoinsIcon);
